var map = {
	"./en.json": [
		"NnYZ",
		0
	],
	"./es.json": [
		"zKlm"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7Jrm";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/translations lazy ^\.\/.*\.json$
// module id = 7Jrm
// module chunks = 1